import { render, staticRenderFns } from "./ProjectVisualSummary.vue?vue&type=template&id=66436ff5&scoped=true"
import script from "./ProjectVisualSummary.vue?vue&type=script&lang=ts"
export * from "./ProjectVisualSummary.vue?vue&type=script&lang=ts"
import style0 from "./ProjectVisualSummary.vue?vue&type=style&index=0&id=66436ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66436ff5",
  null
  
)

export default component.exports